"use client"

import { ExportSettingsDialog } from "../../../components/export-settings/export-settings-dialog"
import { useTr } from "../../../lib/use-tr"
import { useState } from "react"

import { useCampaign } from "@/lib/apps/autoleads/hooks/use-campaign-queries"
import {
  downloadLeadExport,
  leadExportFilename,
} from "@/lib/apps/autoleads/lead-export"

import { ExportFormatMenu } from "./export-format-menu"
import { CAMPAIGN_ACTIONS_T } from "./translations"
import type { Lead } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

export function LeadDownloadMenu({
  lead,
  configurable,
}: {
  lead: Lead
  // Offers the team's export setup next to the formats; off where the reader
  // does not work the lead (shared demo, sample pages).
  configurable: boolean
}) {
  const tr = useTr(CAMPAIGN_ACTIONS_T)
  const [settingsOpen, setSettingsOpen] = useState(false)
  // The setup belongs to the campaign's team. Read only once the dialog
  // opens; on the campaign page the campaign is already cached.
  const campaign = useCampaign(lead.campaign, settingsOpen)

  return (
    <>
      <ExportFormatMenu
        label={tr("downloadLabel")}
        tone="muted"
        className="size-6"
        iconClassName="size-3.5"
        onSelect={(format) =>
          downloadLeadExport(lead.id, format, leadExportFilename(lead, format))
        }
        onConfigure={configurable ? () => setSettingsOpen(true) : undefined}
      />
      {configurable ? (
        <ExportSettingsDialog
          teamId={campaign.data?.team}
          open={settingsOpen}
          onOpenChange={setSettingsOpen}
        />
      ) : null}
    </>
  )
}
